import { cn } from '../../lib/utils';
import { useSocketStatus } from '../../hooks/useSocketStatus';

export function SocketStatusIndicator() {
  const connected = useSocketStatus();

  return (
    <div
      className={cn(
        'flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium',
        'border transition-colors',
        connected
          ? 'border-emerald-500/50 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400'
          : 'border-amber-500/50 bg-amber-500/10 text-amber-600 dark:text-amber-400'
      )}
      title={connected ? 'Realtime updates connected' : 'Realtime updates disconnected'}
    >
      <span className="relative flex h-2 w-2">
        {connected ? (
          <>
            <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-500 opacity-75 animate-ping" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
          </>
        ) : (
          <>
            <span className="absolute inline-flex h-full w-full rounded-full bg-amber-500 opacity-75 animate-ping" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-amber-500 animate-pulse" />
          </>
        )}
      </span>
      <span className="tabular-nums">
        {connected ? 'Live' : 'Offline'}
      </span>
    </div>
  );
}
